import React from 'react';
import styled from 'astroturf/react';
import AvatarBase from 'js/social/shared/Avatar';

const AvatarContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const Avatar = styled(AvatarBase)`
  &:not(:first-child) {
    margin-left: -8px;
  }
`;

export type OverlappingAvatarUser = {
  id: number;
  displayName: string;
  photo: string;
  url?: string;
};

type Props = {
  size?: number;
  users: OverlappingAvatarUser[];
  disableLinks?: boolean;
};

export const OverlappingAvatars: React.FC<Props> = ({
  size = 24,
  users,
  disableLinks = false,
}) => {
  if (users.length <= 0) {
    return null;
  }

  return (
    <AvatarContainer>
      {users.map((user) => (
        <Avatar
          key={user.id}
          style={{ '--size': `${size}px` } as React.CSSProperties}
          fullName={user.displayName}
          photoUrl={user.photo}
          profileUrl={disableLinks ? undefined : user.url}
        />
      ))}
    </AvatarContainer>
  );
};
